import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import PaginaAdministrador from "./Pages/LoginAdmin";
import Home from "./Pages/Home";
import MisCodigos from "./Pages/MisCodigos";
import CompraSegura from "./Pages/CompraSegura";
import Confirmacion from "./Pages/Confirmacion";
import Page404 from "./Pages/Page404";
import Dashboard from "./Pages/Dashboard";
import RutaProtegida from "./components/RutaProtegida";
import ConfigSort from "./Pages/ConfigSort";
import Contacto from "./Pages/Contacto";
import LayoutConSidebar from "./components/LayoutConSidebar";
import InicioAdmin from "./Pages/InicioAdmin";
import { Route, Routes } from "react-router-dom";


function App() {
  return (
    <div className="App">
      <Routes>
        {/* Rutas sin sidebar */}
        <Route path="/" element={<Home />} />
        <Route path="/admin" element={<PaginaAdministrador />} />
        <Route path="/mis-Codigos" element={<MisCodigos />} />
        <Route path="/finalizar-compra/:cantidad" element={<CompraSegura />} />
        <Route path="/confirmacion" element={<Confirmacion />} />
        <Route path="/contactanos" element={<Contacto />} />
        <Route path="*" element={<Page404 />} />


        {/* Rutas con sidebar */}
        <Route element={<RutaProtegida />}>
          <Route element={<LayoutConSidebar />}>
            <Route path="/dashboard" element={<InicioAdmin />} />
            <Route path="/config" element={<ConfigSort />} />
            <Route path="/historial" element={<Dashboard />} />
            <Route path="/usuarios" element={<ConfigSort />} />
            {/* Puedes agregar más rutas aquí si también requieren sidebar */}
          </Route>
        </Route>
      </Routes>
    </div>
  );
}

export default App;
